























































import { AuthErrorCode, Error } from '@luxtag/papybase';
import { Component, Vue } from 'vue-property-decorator';
import { MUTATE_AUTH } from '@/store/modules/auth';
import RecTextField from '@/components/global/input/RecTextField.vue';
import { auth } from '@/plugins/papybase/papybaseInit';
import papybaseConfig from '@/plugins/papybase/papybaseConfig';

@Component({
    components: {
        RecTextField,
    },
    $_veeValidate: { validator: 'new' },
})
export default class ForgotPasswordForm extends Vue {
    public showProgress= false;

    // state of where reset password email has been sent or not
    public formState = true;

    public showPassword = false;

    public form = {
        email: '',
    }

    public async initForgotPassword() {
        // prevent for sign in to work while progress is show up
        if (this.showProgress) return;

        const valid = await this.$validator.validateAll();
        if (valid) {
            this.showProgress = true;
            const url = `${papybaseConfig.baseURL}/#/reset-password/`;
            auth.forgotPassword(this.form.email, url).then((res:any) => {
                this.formState = false;
            }).catch((err: any) => {
                this.addAuthError(err);
            }).finally(() => {
                this.showProgress = false;
            });
        }
    }

    public addAuthError(error:Error) {
        let fieldName = '';

        switch (error.code) {
                case AuthErrorCode.EMAIL_NOT_EXIST:
                    fieldName = 'email';
                    break;
                default:
                    fieldName = 'email';
                    break;
        }

        const field = this.$validator.fields.find({ name: fieldName });
        if (!field) return;

        this.errors.add({
            id: field.id,
            field: field.name,
            msg: error.message,
        });
    }
}
